export default "__VITE_ASSET__CX_a15qG__"